module.exports = __webpack_public_path__ + "static/media/logo.1b212c59.svg";